import { useAuiState } from '@assistant-ui/react';
import { Spark } from '@/components/spark';
import { useNamespaceCopy } from '@/i18n/ns';
import copy from '@/i18n/ns/chat-compaction';

export function useCompactionActive(): boolean {
  return useAuiState((state) => {
    if (state.message.role !== 'assistant' || state.message.status?.type !== 'running')
      return false;
    for (const part of [...state.message.content].reverse()) {
      if (part.type !== 'data' || part.name !== 'ponevaCompaction') continue;
      return (part.data as { status?: unknown } | null)?.status === 'running';
    }
    return false;
  });
}

export function CompactionStatus() {
  const active = useCompactionActive();
  const strings = useNamespaceCopy(copy);
  if (!active) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      data-slot="chat-compaction-status"
      className="pc-compaction-status"
    >
      <Spark
        size={14}
        state="thinking"
        withRays={false}
        body="currentColor"
        hole="var(--pc-paper)"
      />
      <span>{strings.summarizing}</span>
    </div>
  );
}
